export default function isNumberUnit(obj) {
    if (obj == null)
        return false;
    if (typeof obj !== 'object')
        return false;
    return '_number' in obj && 'unit' in obj && 'unitType' in obj && 'baseUnit' in obj;
}
